import React from "react";

const About = () => {
  return (
      <div className='page-content'>
          <div className='page-banner-content mb-5'>
              <div className='container'>
                  <div className='section-title-div wow animate__animated animate__fadeInDown'>
                      <h1>
                          Cloud Automation &
                          <span className='text-primary'> Orchestration</span>
                      </h1>
                      <p>
                          Empowering you to optimize your distributed infrastructure, enhance visibility, maintain security, and reduce complexity.
                      </p>
                  </div>
              </div>

          </div>

          <div className='page-banner mb-5'>
              <div className='container'>
                  <div className='page-img wow animate__animated animate__zoomIn'>
                      <img
                          src="/assets/images/cloud-banner.png"
                          alt="img"
                          className="img-fluid w-100"
                      />
                  </div>
              </div>
          </div>

          <div className='feature-section'>
              <div className='container'>
                  <div className='row row-gap-3'>
                      <div className='col-md-4'>
                          <div className='feature-card wow animate__animated animate__zoomIn'>
                              <div className='fc-body'>
                                  <h3 className='text-primary'>
                                      Templated Cloud Design
                                  </h3>
                                  <p>
                                      Sem integer vitae justo eget magna fermentum iaculis. Feugiat scelerisque varius
                                      morbi enim nunc faucibus.
                                  </p>
                              </div>
                          </div>
                      </div>

                      <div className='col-md-4'>
                          <div className='feature-card wow animate__animated animate__zoomIn'>
                              <div className='fc-body'>
                                  <h3 className='text-primary'>
                                      Event-Driven Automation Engine
                                  </h3>
                                  <p>
                                      Et netus et malesuada fames turpis egestas. Magna etiam tempor orci eu lobortis
                                      nibh interdum phasellus tellus.
                                  </p>
                              </div>
                          </div>
                      </div>

                      <div className='col-md-4'>
                          <div className='feature-card wow animate__animated animate__zoomIn'>
                              <div className='fc-body'>
                                  <h3 className='text-primary'>
                                      Cloud Abstraction Interface
                                  </h3>
                                  <p>
                                      Et netus et malesuada fames turpis egestas. Magna etiam tempor orci eu lobortis
                                      nibh interdum phasellus tellus.
                                  </p>
                              </div>
                          </div>
                      </div>

                      <div className='col-md-4'>
                          <div className='feature-card wow animate__animated animate__zoomIn'>
                              <div className='fc-body'>
                                  <h3 className='text-primary'>
                                      Cloud Resource Manager
                                  </h3>
                                  <p>
                                      Sem integer vitae justo eget magna fermentum iaculis. Feugiat scelerisque varius
                                      morbi enim nunc faucibus.
                                  </p>
                              </div>
                          </div>
                      </div>

                      <div className='col-md-4'>
                          <div className='feature-card wow animate__animated animate__zoomIn'>
                              <div className='fc-body'>
                                  <h3 className='text-primary'>
                                      Orchestration Engine
                                  </h3>
                                  <p>
                                      Et netus et malesuada fames turpis egestas. Magna etiam tempor orci eu lobortis nibh interdum phasellus tellus.
                                  </p>
                              </div>
                          </div>
                      </div>
                      <div className='col-md-4'>
                          <div className='feature-card wow animate__animated animate__zoomIn'>
                              <div className='fc-body'>
                                  <h3 className='text-primary'>
                                      Governance & Security Manager
                                  </h3>
                                  <p>
                                      Scelerisque eu ultrices vitae auctor eu augue ut lectus arcu. Ac tortor vitae purus faucibus ornare suspendisse sed nisi.
                                  </p>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <div className='consectetuer-section bg-black'>
              <div className='container-fluid'>
                  <div className='section-title-div text-center wow animate__animated animate__fadeInDown'>
                      <h1 className='text-white'>

                          <span className='text-primary'>consectetuer adipiscing</span> tincidunt ultricies
                      </h1>

                  </div>
                  <div className='row row-cols-2 row-cols-sm-2 row-cols-md-5 row-gap-3'>
                      <div className='col'>
                          <div className='cns-card wow animate__animated animate__zoomIn h-100'>
                              <h1>1.</h1>
                              <p className='text-primary'>
                                  Assessment and<br/>
                                  Planning
                              </p>
                          </div>
                      </div>
                      <div className='col'>
                          <div className='cns-card wow animate__animated animate__zoomIn h-100'>
                              <h1>2.</h1>
                              <p className='text-primary'>
                                  Application<br/>
                                  Modernization
                              </p>
                          </div>
                      </div>
                      <div className='col'>
                          <div className='cns-card wow animate__animated animate__zoomIn h-100'>
                              <h1>3.</h1>
                              <p className='text-primary'>
                                  Data<br/>
                                  Migration
                              </p>
                          </div>
                      </div>
                      <div className='col'>
                          <div className='cns-card wow animate__animated animate__zoomIn h-100'>
                              <h1>4.</h1>
                              <p className='text-primary'>
                                  Smooth<br/>
                                  Transition
                              </p>
                          </div>
                      </div>
                      <div className='col'>
                          <div className='cns-card wow animate__animated animate__zoomIn h-100'>
                              <h1>5.</h1>
                              <p className='text-primary'>
                                  Ongoing Support &<br/>
                                  Optimization
                              </p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>


          <div className='customer-approach-section'>
              <div className='container'>

                  <div className='row'>
                      <div className='col-md-12'>
                          <div className='section-title-div wow animate__animated animate__fadeInDown'>
                              <h1>
                                  Customer Centric
                                  <span className='text-primary'>Approach</span>
                              </h1>
                          </div>


                      </div>
                      <div className='row row-gap-3'>
                          <div className='col-md-7 order-2 order-sm-2 order-md-1'>
                              <div className='cas-collapes  wow animate__animated animate__fadeInLeft'>
                                  <div className="accordion" id="accordionExample">
                                      <div className="accordion-item">
                                          <h2 className="accordion-header" id="heading1">
                                              <button className="accordion-button" type="button"
                                                      data-bs-toggle="collapse"
                                                      data-bs-target="#collapse1" aria-expanded="true"
                                                      aria-controls="collapse1">
                                                  24/7 Support
                                              </button>
                                          </h2>
                                          <div id="collapse1" className="accordion-collapse collapse show"
                                               aria-labelledby="heading1" data-bs-parent="#accordionExample">
                                              <div className="accordion-body">
                                                  Dedicated to helping customers achieve their goals and maximize the
                                                  value
                                                  of their technology investments, with a strong focus on customer
                                                  satisfaction.
                                              </div>
                                          </div>
                                      </div>
                                      <div className="accordion-item">
                                          <h2 className="accordion-header" id="heading2">
                                              <button className="accordion-button collapsed" type="button"
                                                      data-bs-toggle="collapse" data-bs-target="#collapse2"
                                                      aria-expanded="false" aria-controls="collapse2">
                                                  Commitment to Customer Success
                                              </button>
                                          </h2>
                                          <div id="collapse2" className="accordion-collapse collapse"
                                               aria-labelledby="heading2" data-bs-parent="#accordionExample">
                                              <div className="accordion-body">
                                                  Dedicated to helping customers achieve their goals and maximize the
                                                  value
                                                  of their technology investments, with a strong focus on customer
                                                  satisfaction.
                                              </div>
                                          </div>
                                      </div>
                                      <div className="accordion-item">
                                          <h2 className="accordion-header" id="heading3">
                                              <button className="accordion-button collapsed" type="button"
                                                      data-bs-toggle="collapse" data-bs-target="#collapse3"
                                                      aria-expanded="false" aria-controls="collapse3">
                                                  Security-Focused
                                              </button>
                                          </h2>
                                          <div id="collapse3" className="accordion-collapse collapse"
                                               aria-labelledby="heading3" data-bs-parent="#accordionExample">
                                              <div className="accordion-body">
                                                  Dedicated to helping customers achieve their goals and maximize the
                                                  value
                                                  of their technology investments, with a strong focus on customer
                                                  satisfaction.
                                              </div>
                                          </div>
                                      </div>
                                      <div className="accordion-item">
                                          <h2 className="accordion-header" id="heading4">
                                              <button className="accordion-button collapsed" type="button"
                                                      data-bs-toggle="collapse" data-bs-target="#collapse4"
                                                      aria-expanded="false" aria-controls="collapse4">
                                                  Extensive Knowledge Base
                                              </button>
                                          </h2>
                                          <div id="collapse4" className="accordion-collapse collapse"
                                               aria-labelledby="heading4" data-bs-parent="#accordionExample">
                                              <div className="accordion-body">
                                                  Dedicated to helping customers achieve their goals and maximize the
                                                  value
                                                  of their technology investments, with a strong focus on customer
                                                  satisfaction.
                                              </div>
                                          </div>
                                      </div>
                                      <div className="accordion-item">
                                          <h2 className="accordion-header" id="heading5">
                                              <button className="accordion-button collapsed" type="button"
                                                      data-bs-toggle="collapse" data-bs-target="#collapse5"
                                                      aria-expanded="false" aria-controls="collapse5">
                                                  Flexible Deployment Options
                                              </button>
                                          </h2>
                                          <div id="collapse5" className="accordion-collapse collapse"
                                               aria-labelledby="heading5" data-bs-parent="#accordionExample">
                                              <div className="accordion-body">
                                                  Dedicated to helping customers achieve their goals and maximize the
                                                  value
                                                  of their technology investments, with a strong focus on customer
                                                  satisfaction.
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div className='col-md-5 order-1 order-sm-1 order-md-2'>
                              <div className='cas-img  wow animate__animated animate__fadeInRight'>
                                  <img
                                      src="/assets/images/approach-img.png"
                                      alt="img"
                                      className="img-fluid w-100"
                                  />
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

      </div>
  );
};

export default About;
